import { useParams } from "react-router-dom";
import { errorToast, successToast } from "../toast";
import MainLayout from "../components/MainLayout";
import ContentContainer from "../components/ContentContainer";
import IconButton from "../components/IconButton";
import { ArrowLeft } from "@phosphor-icons/react";
import Typography from "../components/Typography";
import Separator from "../components/Separator";
import {
    useEmissionsSourceById,
    useUpdateEmissionsSource,
} from "../api/emissions-sources";
import { EditEmissionsSourceFormValues } from "../components/EditEmissionsSourceForm/EditEmissionsSourceFormValues";
import EditEmissionsSourceForm from "../components/EditEmissionsSourceForm/EditEmissionsSourceForm";

const EmissionsSourceEditPage = () => {
    const { id } = useParams();
    const { emissionsSource, isLoading } = useEmissionsSourceById(Number(id));

    const [request, isAddingEmissionsSource] = useUpdateEmissionsSource(
        Number(id)
    );

    const handleSubmit = async (values: EditEmissionsSourceFormValues) => {
        const response = await request(values);

        if (!response.success) {
            errorToast(
                "There was a problem updating the emissions source - please try again"
            );
            return;
        }

        successToast("Emissions source updated");
        window.history.back();
    };

    if (!id || !emissionsSource) return null;

    return (
        <MainLayout isLoading={isLoading}>
            <ContentContainer className="pt-14 pb-11">
                <div className="flex flex-col gap-6 sm:gap-0 sm:flex-row items-center pb-5">
                    <div className="flex items-center">
                        <IconButton
                            label="Back"
                            icon={ArrowLeft}
                            iconSize="large"
                            className="mr-3"
                            onClick={() => window.history.back()}
                        />
                        <Typography variant="headline-small" component="h1">
                            Edit asset
                        </Typography>
                    </div>
                </div>
                <Separator className="mb-8" />
                <EditEmissionsSourceForm
                    onSubmit={handleSubmit}
                    isSubmitting={isAddingEmissionsSource}
                    onCancel={() => window.history.back()}
                    initialValues={emissionsSource}
                    id={Number(id)}
                />
            </ContentContainer>
        </MainLayout>
    );
};

export default EmissionsSourceEditPage;
